import { t } from "@lingui/core/macro";

export const OFFER_LIST_TEXT = () => {
  return {
    storesNodeList: t`Other deals near you`,
    popularNodeList: t`Other deals you might like`,
  };
};
